import { Views } from "@singularsystems/neo-react";
import { NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class SearchFieldVM extends Views.ViewModelBase {
  public isSearching = false;
  public hideNoResultDialog = false;
}
